import { Component, OnInit } from '@angular/core';
import { Auth }      from '../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-login',
  templateUrl: 'login.component.html',
  styleUrls: [ 'login.component.css' ]
})

export class LoginComponent implements OnInit{

  constructor(private auth: Auth) {}


  ngOnInit(){
    if (!this.auth.authenticated())
      this.auth.login("","")
  }
}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts